export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50">桔子视频</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
              桔子视频是一个面向华语观众的免费高清视频聚合平台，每日同步西瓜视频和丝瓜视频的最新影视资源。
              电视剧大全高清在线观看、全集不缓冲，满足您对视频内容的最新搜索需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#index" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精彩索引</a></li>
              <li><a href="#ranking" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#cards" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">内容板块</h4>
            <ul className="space-y-2">
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">热播电视剧</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">院线大片</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">综艺娱乐</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">动漫番剧</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质平台与我们联系合作。
            </p>
            <div className="mt-4 flex gap-3">
              <a href="#contact" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-200 text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-200 text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-200 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024 桔子视频 · 西瓜视频免费在线观看高清全集 | 丝瓜视频不缓冲电视剧大全
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">内容声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}